import React, { createContext, useContext, useState } from 'react';

const SiteContext = createContext();


export const SiteProvider = ({ children }) => {
  const [selectedSiteId, setSelectedSiteId] = useState(null);
  const resetSite = () => setSelectedSiteId(null);
  return (
    <SiteContext.Provider value={{ selectedSiteId, setSelectedSiteId, resetSite }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => useContext(SiteContext);
